import { COAGroup } from '@futrli-sdk/predict';
import { API_PATHS, REQUEST_METHODS, ROUTE_PARAMS, interpolatePathParams } from '@futrli/shared-services';

import { makeRequestWithResponse } from './shared';
import {
  COARecategoriseAccountPayload,
  COASwitchRulePayload,
  COAUpdateFullStructurePayload,
  CreateGroupPayload
} from '../../chart-of-accounts/types';
import { COAFullStructureWithDisplayCodesFlag } from './types/chart-of-accounts';

export const fetchChartOfAccountsFullStructure = async (
  workspaceId: string,
  organisationId: string
): Promise<COAFullStructureWithDisplayCodesFlag> => {
  const path = interpolatePathParams(API_PATHS.CHART_OF_ACCOUNTS_FULL_STRUCTURE, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId
  });

  return makeRequestWithResponse<COAFullStructureWithDisplayCodesFlag>({ url: path });
};

export const createGroup = async (
  workspaceId: string,
  organisationId: string,
  data: Partial<CreateGroupPayload>
): Promise<COAGroup> => {
  const path = interpolatePathParams(API_PATHS.COA_CREATE_GROUP, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId
  });

  return makeRequestWithResponse<COAGroup>({ url: path, method: REQUEST_METHODS.POST, data });
};

export const updateGroup = async (
  workspaceId: string,
  organisationId: string,
  groupId: string,
  data: Partial<CreateGroupPayload>
): Promise<COAGroup> => {
  const path = interpolatePathParams(API_PATHS.COA_UPDATE_GROUP, {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.GROUP_ID]: groupId
  });

  return makeRequestWithResponse<COAGroup>({ url: path, method: REQUEST_METHODS.PATCH, data });
};

export const deleteGroup = async (workspaceId: string, organisationId: string, groupId: string): Promise<void> => {
  const path = interpolatePathParams(API_PATHS.COA_UPDATE_GROUP, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.GROUP_ID]: groupId
  });

  return makeRequestWithResponse<void>({ url: path, method: REQUEST_METHODS.DELETE });
};

export const updatedCOAStructure = async (
  workspaceId: string,
  organisationId: string,
  data: COAUpdateFullStructurePayload
): Promise<void> => {
  const path = interpolatePathParams(API_PATHS.CHART_OF_ACCOUNTS_FULL_STRUCTURE, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId
  });

  return makeRequestWithResponse({ url: path, data, method: REQUEST_METHODS.PUT });
};

export const recategoriseAccount = async (
  workspaceId: string,
  organisationId: string,
  data: COARecategoriseAccountPayload
): Promise<void> => {
  const path = interpolatePathParams(API_PATHS.RECATEGORIZE_ACCOUNT, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId
  });

  return makeRequestWithResponse({ url: path, data, method: REQUEST_METHODS.POST });
};

export const setSwitchRuleForAccount = async (
  workspaceId: string,
  organisationId: string,
  accountId: string,
  data: COASwitchRulePayload
): Promise<void> => {
  const path = interpolatePathParams(API_PATHS.SWITCH_RULE, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ACCOUNT_ID]: accountId
  });

  return makeRequestWithResponse({ url: path, data, method: REQUEST_METHODS.PUT });
};

export const deleteSwitchRuleForAccount = async (
  workspaceId: string,
  organisationId: string,
  accountId: string
): Promise<void> => {
  const path = interpolatePathParams(API_PATHS.SWITCH_RULE, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ACCOUNT_ID]: accountId
  });

  return makeRequestWithResponse({ url: path, method: REQUEST_METHODS.DELETE });
};
